 <!-- <div class="nav navbar-nav navbar-right navbar-right-container">
<div class="faq-container">
<span (clickOutside)="onClickedOutside()">
<span (click)="isVisible=!isVisible" class="faq-image">
  <i class="fa fa-question-circle" pTooltip="FAQs" tooltipPosition="left"></i>
</span>
<p-accordion class="faq-wrapper" *ngIf="isVisible" >
  <div *ngFor="let module of modules">
    <p-accordionTab class="faq-accordion" [selected]="module.Selected" (click)="toggleTab(module)" header={{module.ModuleName}}>
      <div *ngFor="let faq of module.FaqData" class="faq-link-wrapper">
        <span><i class="fa fa-hand-o-up faq-link"></i></span>
        <span><a [href]="faq.Link" target="_blank">{{faq.Name}}</a></span>
      </div>
    </p-accordionTab>
  </div>
  <div *ngIf="modules.length===0">
    No FAQs are available
  </div>
</p-accordion>
</span>
</div>
</div> -->
<div class="row">
  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
    <ol class="breadcrumb bc-3" style="margin-top:10px;" >
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Help & Support</a>
      </li>
      
    </ol>
    <div class="center">
      <img src="assets/images/target-zero.png" style="width: 52%;margin-top:165px;" />

    </div>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

  <div class="faq-container" style="margin-top:120px;width:400px;">
  <!-- <span (clickOutside)="onClickedOutside()">
  <span (click)="isVisible=!isVisible" class="faq-image">
    <i class="fa fa-question-circle" pTooltip="FAQs" tooltipPosition="left"></i>
  </span> -->
 <p-accordion class="faq-wrapper">
    <div *ngFor="let module of modules">
      <p-accordionTab class="faq-accordion" [selected]="module.Selected" (click)="toggleTab(module)" header={{module.ModuleName}}>
        <div *ngFor="let faq of module.FaqData" class="faq-link-wrapper">
          <span><i class="fa fa-hand-o-up faq-link"></i></span>
          <span><a [href]="faq.Link" target="_blank">{{faq.Name}}</a></span>
        </div>
      </p-accordionTab>
    </div>
    <div *ngIf="modules.length===0">
      No FAQs are available
    </div>
  </p-accordion>
  </div>
</div>
</div>